import Authorization from "components/routing/Authorization"
import {Link, Route, Routes, Navigate, useParams} from "react-router-dom"
import {Button, Layout, Typography} from "antd"
import Label from "components/Label"
import {useEffect, useState} from "react"
import {sessionService} from "services/session.service"
import {Role} from "util/role"
import Introduction from "components/patient/Introduction"

const {Content} = Layout

export default function PatientPage() {
	return (
		<Authorization roles={Role.Patient}>
			<Routes>
				<Route path="session/">
					<Route path=":sessionId/">
						<Route path="" element={<PatientContent/>}/>
						<Route path="edit" element={<Edit/>}/>
					</Route>
				</Route>
				<Route path="">
					<Route path="" element={<Join/>}/>
				</Route>
			</Routes>
		</Authorization>
	)
}

function PatientContent() {
	return (
		<Layout className="content_container">
			<Content className="content_container">
				<Introduction/>
			</Content>
		</Layout>
	)
}

function Join() {
	const [activeSession, setActiveSession] = useState(null)

	const updateData = () => sessionService.getActiveSession().then(setActiveSession)
	useEffect(updateData, [])

	if (activeSession) {
		if(["PREFERENCES_PROVIDED", "ALL_INFO_PROVIDED", "STARTED"].includes(activeSession.status)) {
			return <Navigate to={`session/${activeSession.sessionId}/edit`} />
		}
		return (
			<div className="join">
				<div className="element">
					<Typography.Paragraph>
						<Label id="patient.join.info"/>
					</Typography.Paragraph>
				</div>
				<div className="element">
					<Button size="large" type="primary">
						<Link to={`session/${activeSession.sessionId}`}>
							<Label id={"patient.join.button"}/>
						</Link>
					</Button>
				</div>
			</div>
		)
	}
	return (
		<div className="no-active-session">
			<Label id={"patient.noactivesession"}/>
		</div>
	)
}

function Edit() {
	const {sessionId} = useParams()
	
	return (
		<div className="join">
			<div className="element">
				<Typography.Paragraph>
					<Label id="patient.join.edit"/>
				</Typography.Paragraph>
			</div>
			<div className="element">
				<Button size="large" type="primary">
					<Link to={`/patient/session/${sessionId}?edit=true`}>
						<Label id={"patient.join.edit.button"}/>
					</Link>
				</Button>
			</div>
		</div>
	)
}
